module.exports = __webpack_public_path__ + "img/Dashboard.b5c3cefb.svg";